/**
 * HELLYWEAR DARK — JS v4.0
 */
(function () {
  'use strict';

  function initHeaderGhost() {
    var header = document.querySelector('.header-wrapper');
    if (!header) return;
    var firstSection = document.querySelector('.content-for-layout .shopify-section:first-child');
    var hasHero = firstSection && firstSection.querySelector('.hw-hero');

    function updateHeader() {
      var scrollY = window.scrollY || window.pageYOffset;
      if (hasHero) {
        if (scrollY < 80) {
          header.classList.remove('header-wrapper--scrolled');
          header.classList.add('header-wrapper--transparent');
        } else {
          header.classList.add('header-wrapper--scrolled');
          header.classList.remove('header-wrapper--transparent');
        }
      } else {
        if (scrollY > 50) { header.classList.add('header-wrapper--scrolled'); }
        else { header.classList.remove('header-wrapper--scrolled'); }
      }
    }

    if (hasHero) header.classList.add('header-wrapper--transparent');
    window.addEventListener('scroll', updateHeader, { passive: true });
    updateHeader();
  }

  function initScrollReveal() {
    var style = document.createElement('style');
    style.textContent = '.hw-fade-up{opacity:0;transform:translateY(32px);transition:opacity .75s cubic-bezier(.25,.46,.45,.94),transform .75s cubic-bezier(.25,.46,.45,.94)}.hw-fade-up.hw-visible{opacity:1;transform:translateY(0)}';
    document.head.appendChild(style);

    var selectors = ['.card-wrapper','.collection__title','.image-with-text__content','.rich-text__wrapper','.footer-block'];
    var elements = [];
    selectors.forEach(function(sel) {
      document.querySelectorAll(sel).forEach(function(el) {
        if (!el.classList.contains('scroll-trigger') && !el.closest('.hw-hero')) {
          el.classList.add('hw-fade-up');
          elements.push(el);
        }
      });
    });

    document.querySelectorAll('.grid.product-grid').forEach(function(grid) {
      grid.querySelectorAll('.card-wrapper.hw-fade-up').forEach(function(card, i) {
        card.style.transitionDelay = Math.min(i * 0.07, 0.5) + 's';
      });
    });

    if (!elements.length) return;
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) { entry.target.classList.add('hw-visible'); observer.unobserve(entry.target); }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -30px 0px' });
    elements.forEach(function(el) { observer.observe(el); });
  }

  function initHeroVideo() {
    var video = document.querySelector('.hw-hero__video:not(iframe)');
    if (!video) return;
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) { video.play().catch(function(){}); } else { video.pause(); }
      });
    }, { threshold: 0.3 });
    observer.observe(video);
  }

  function init() {
    initHeaderGhost();
    initScrollReveal();
    initHeroVideo();
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
})();
